var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "cs-screen", attrs: { id: "cs-screen" } }, [
    _c(
      "div",
      {
        staticClass: "cs-components-container",
        attrs: { "data-datepicker-scroller": "true" },
      },
      _vm._l(_vm.screen.components, function (component, index) {
        return _c(
          "div",
          {
            key: component.id,
            staticClass: "cs-component",
            class: `${component.componentName}-container`,
            attrs: { id: `${component.componentName}-${index}` },
          },
          [
            !_vm.componentLoadComplete ? _c("cs-loadinglogo") : _vm._e(),
            _c(
              "transition",
              { attrs: { name: "cs-fade", mode: "out-in" } },
              [
                _c(_vm.dynamicComponent(component.componentName), {
                  key: _vm.getComponentKey(component),
                  tag: "component",
                  attrs: {
                    index: index,
                    "component-settings": component.componentSettings,
                    id: component.componentSettingsTemplateId,
                    title: component.translatedName || component.name,
                    tooltip: component.tooltip,
                    user: _vm.user,
                    theme: _vm.theme,
                    entities: _vm.entities,
                    "header-logo": _vm.headerLogo,
                    "component-data": component,
                    status: component.status,
                    "root-level-help-text": _vm.rootLevelHelpText,
                  },
                  on: {
                    showNotification: _vm.showNotification,
                    updateTheme: _vm.onUpdateTheme,
                    componentLoaded: _vm.setDynamicComponentState,
                    componentDestroyed: _vm.setDynamicComponentState,
                    "open-fullscreen-wizard": _vm.openFullscreenWizard,
                  },
                }),
              ],
              1
            ),
          ],
          1
        )
      }),
      0
    ),
    _c(
      "div",
      { staticClass: "cs-overlay-slider-wrapper" },
      [
        _vm.overlayVisible
          ? _c(
              "cs-overlay-slider-keyframe",
              {
                staticClass: "cs-bc-light cs-bd-thin-right cs-screen-form",
                attrs: {
                  direction: "negative-left",
                  "size-from-div-selector": _vm.overlaySliderTarget,
                  "style-object-override": _vm.customSliderStyles,
                },
              },
              [
                !_vm.formLoadingComplete ? _c("cs-loadinglogo") : _vm._e(),
                _vm.decoratedSiteConfigForm != undefined
                  ? _c("cs-form", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.formLoadingComplete,
                          expression: "formLoadingComplete",
                        },
                      ],
                      attrs: {
                        "header-arrow-direction": "right",
                        "config-mode": true,
                        settings: _vm.decoratedSiteConfigForm,
                      },
                      on: {
                        toggleModal: _vm.toggleOverlay,
                        saveConfigData: _vm.onSaveConfigData,
                        deleteConfigData: _vm.onDeleteConfigData,
                        childLoaded: _vm.onOverlayFormLoaded,
                        destroyingForm: _vm.onDestroyingForm,
                        showNotification: _vm.showNotification,
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
        _vm.fullScreenWizardVisible
          ? _c(
              "cs-overlay-slider-keyframe",
              {
                class: "cs-fullscreen-wizard-slider",
                attrs: {
                  direction: "negative-left",
                  "size-from-div-selector": ".cs-app",
                  "style-object-override": {
                    position: "fixed",
                    width: "100%",
                    height: "100%",
                    zIndex: "100",
                  },
                },
              },
              [
                _c(_vm.fullScreenWizardComponent, {
                  tag: "component",
                  attrs: {
                    "component-data": _vm.fullScreenWizardComponentData,
                  },
                  on: {
                    close: _vm.onCloseFullScreenWizard,
                    showNotification: _vm.showNotification,
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }